import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Notification, { VARIANTS } from '@jobcase/react_pattern_library/components/Notification';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import actions from '../../redux/nodes/authentication/actions';

const StyledNotification = styled(Notification)`
  margin-bottom: ${styles.spacing.medium}px;
`;

const Alert = ({ alert }) => {
  const dispatch = useDispatch();

  const clearError = () => {
    dispatch({
      type: actions.TYPES.SET_LOGIN_ERROR,
      payload: null,
    });
  };

  return (alert && (
    <StyledNotification variant={VARIANTS.ERROR} onClick={clearError} hideCloseButton={false}>
      {typeof alert === 'object' ? alert.login : alert}
    </StyledNotification>
  ));
};

Alert.propTypes = {
  /*
  * String to place in the alert header
  */
  alert: PropTypes.oneOf([PropTypes.string, PropTypes.shape({ login: PropTypes.string })]),
};

Alert.defaultProps = {
  alert: null,
};

export default Alert;
